import { FC } from 'react'
import { IMetricCard } from 'types/ui/metricCard.interface'
import {
  MetricCardWrapper,
  MetricCardTop,
  MetricCardBody,
  MetricTextBlock,
  MetricValueRow,
  MetricTopRight,
  MetricIconChip,
  MetricTrend,
  MetricValue,
  MetricLabel,
  MetricSublabel,
} from './MetricCard.styled'

export const MetricCard: FC<IMetricCard> = ({
  label,
  value,
  icon,
  trailing,
  sublabel,
  trend,
  accentColor,
  layout = 'stacked',
}) => {
  const rate = (trailing || trend) && (
    <MetricTopRight>
      {trailing}
      {trend && (
        <MetricTrend $positive={trend.positive}>
          {trend.positive ? '▲' : '▼'} {trend.value}
        </MetricTrend>
      )}
    </MetricTopRight>
  )

  if (layout === 'inline') {
    return (
      <MetricCardWrapper $accent={accentColor} $layout='inline'>
        <MetricCardBody>
          {icon && <MetricIconChip $accent={accentColor}>{icon}</MetricIconChip>}
          <MetricTextBlock>
            <MetricValue>{value}</MetricValue>
            <MetricLabel>{label}</MetricLabel>
            {sublabel && <MetricSublabel>{sublabel}</MetricSublabel>}
          </MetricTextBlock>
        </MetricCardBody>
        {rate}
      </MetricCardWrapper>
    )
  }

  return (
    <MetricCardWrapper $accent={accentColor} $layout='stacked'>
      {icon && (
        <MetricCardTop>
          <MetricIconChip $accent={accentColor}>{icon}</MetricIconChip>
          {rate}
        </MetricCardTop>
      )}
      <MetricValueRow>
        <MetricValue>{value}</MetricValue>
        {!icon && rate}
      </MetricValueRow>
      <MetricLabel>{label}</MetricLabel>
      {sublabel && <MetricSublabel>{sublabel}</MetricSublabel>}
    </MetricCardWrapper>
  )
}
